import { Component, Input, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { BottombarMenusComponent } from './../bottombar-menus.component';
import { GisMapFloodForecastComponent } from 'src/app/main/shared/gis-map-flood-forecast/gis-map-flood-forecast.component';

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss']
})
export class LegendComponent implements OnInit {

  @Input() map: any;
  @Input() layersList: any;

  legendData: any = [];

  constructor(
    private btmBarMenusComp: BottombarMenusComponent,
    private gisFF: GisMapFloodForecastComponent
    ) { }

  ngOnInit() {
    this.UpdateLegend();
    const legendContainer = L.DomUtil.get('legend');

    if (legendContainer.innerHTML === '') {
      const block = L.DomUtil.create('div', 'legend-block', legendContainer);
      block.innerHTML = '<h1> No Data To Display </h1>';
    }
    this.map.on('click', (e) => {
      this.btmBarMenusComp.bottomBarOpen = true;
    });
  }

  UpdateLegend() {
    this.legendData = this.gisFF.htmlLegendObjects;
    this.legendData.forEach(legend => {
      const overlay = legend.layer;
      if (overlay.options.visible) {
        let html;
        let label;
        let style;
        let legendContainer;
        legendContainer = L.DomUtil.get('legend');

        const block = L.DomUtil.create('div', 'legend-block', legendContainer);
        if (legend.legend && legend.legend.name) {
          const header = L.DomUtil.create('h6', null, block);
          L.DomUtil.create('span', null, header).innerHTML = legend.legend.name;
        }

        legend.legend.elements.forEach(element => {
          html = element.html;
          label = element.label;
          style = element.style;
          this.addElement(html, label, style, block);
        });
      }


    });
  }

  addElement(html, label, style, container) {
    const row = L.DomUtil.create('div', 'legend-row', container);
    if (html && !label && !style) {
      row.innerHTML = html;
      return;
    }

    const symbol = L.DomUtil.create('div', 'symbol', row);
    if (html && html !== '') {
      symbol.innerHTML = html;
    }

    if (style && html == '') {
      let symbolhtml = '<div style="background-color:' + style['background-color'] + ';width: 13px; height: 13px ; float:left"></div>';
      if (label) {
        symbolhtml = symbolhtml + '<div style="float:left ; margin-left :10px;font-size:14px">' + label + '</div> <br/>';
      }
      symbol.innerHTML = symbolhtml;
    }
  }

}
